import { s } from '../lib/sx'
import { PageHero } from '../components/PageHero'
import { Plate } from '../components/Plate'
import { copy } from '../content/copy'
import { news } from '../content/news'

export function News() {
  return (
    <div>
      <PageHero eyebrow="News & insights" title={copy.news.headline} />
      <section style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,64px) clamp(18px,4vw,32px) 100px;')}>
        {news.map((n, i) => (
          <article key={i} style={s('display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,240px),1fr));gap:clamp(24px,3vw,48px);padding:38px 0;border-bottom:1px solid #DCE0E5;align-items:start;')}>
            <div>
              <div style={s("font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.14em;color:#7E8894;")}>{n.date}</div>
              <div style={s("display:inline-block;font-family:'IBM Plex Mono',monospace;font-size:10px;letter-spacing:0.16em;text-transform:uppercase;color:#A8500F;border:1px solid #A8500F;padding:4px 8px;margin-top:12px;")}>{n.tag}</div>
            </div>
            <div>
              <h2 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:26px;line-height:1.2;letter-spacing:-0.02em;margin:0 0 12px;')}>{n.title}</h2>
              <p style={s('font-size:16px;line-height:1.65;color:#566070;margin:0;')}>{n.body}</p>
            </div>
            <Plate box="aspect-ratio:4/3;" src={n.image} caption="" />
          </article>
        ))}
      </section>
    </div>
  )
}
